import { Dispatch, SetStateAction } from 'react';
/**
 * @param current - O valor booleano atual do estado principal.
 * @param setValue - Função de atualização (useState) para o estado principal.
 * @param setDependent - (Opcional) Função de atualização para o estado dependente que será resetado para `false`.
 * Caso o usuário desative a opção principal, a opção dependente também será desativada automaticamente.
 */
export const toggleWithCascade = (
  current: boolean,
  setValue: Dispatch<SetStateAction<boolean>>,
  setDependent?: Dispatch<SetStateAction<boolean>>,
) => {
  const next = !current;
  setValue(next);

  if (!next && setDependent) {
    setDependent(false);
  }
};
